var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecurso6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 142.98 132.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:gray;stroke-miterlimit:10;stroke-width:6.01px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_1189",
    "data-name": "Rect\\xE1ngulo 1189",
    className: "cls-1",
    d: "M72.06,85.36h0A14.39,14.39,0,0,1,86.45,99.75v5.18a14.4,14.4,0,0,1-14.39,14.4h0a14.4,14.4,0,0,1-14.4-14.4V99.75A14.4,14.4,0,0,1,72.06,85.36Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_131",
    "data-name": "Elipse 131",
    className: "cls-1",
    cx: 72.05,
    cy: 75.21,
    r: 11.99
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_467",
    "data-name": "Trazado 467",
    className: "cls-1",
    d: "M140,44.41v63.4a21.3,21.3,0,0,1-20.49,22h-96A21.25,21.25,0,0,1,3,107.87V44.41a8.73,8.73,0,0,1,8.41-9H29.68a8.72,8.72,0,0,1,8.42,9h0V95.88a8.72,8.72,0,0,0,8.41,9H99.59a8.72,8.72,0,0,0,8.42-9h0V44.41a8.72,8.72,0,0,1,8.4-9H131.5a8.72,8.72,0,0,1,8.42,9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1190",
    "data-name": "Rect\\xE1ngulo 1190",
    className: "cls-1",
    x: 3.01,
    y: 3.01,
    width: 27.22,
    height: 48.6,
    rx: 12.02
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1191",
    "data-name": "Rect\\xE1ngulo 1191",
    className: "cls-1",
    x: 30.21,
    y: 3.01,
    width: 27.22,
    height: 48.6,
    rx: 12.02
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1192",
    "data-name": "Rect\\xE1ngulo 1192",
    className: "cls-1",
    x: 57.43,
    y: 3.01,
    width: 27.22,
    height: 48.6,
    rx: 12.02
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1193",
    "data-name": "Rect\\xE1ngulo 1193",
    className: "cls-1",
    x: 85.54,
    y: 3.01,
    width: 27.22,
    height: 48.6,
    rx: 12.02
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1194",
    "data-name": "Rect\\xE1ngulo 1194",
    className: "cls-1",
    x: 112.75,
    y: 3.01,
    width: 27.22,
    height: 48.6,
    rx: 12.02
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurso6);
export default __webpack_public_path__ + "static/media/Recurso 6.6affe3b8a5894a86f145024e404974fd.svg";
export { ForwardRef as ReactComponent };